import { render } from "./AllOrders.vue?vue&type=template&id=b694620a&scoped=true"
import script from "./AllOrders.vue?vue&type=script&lang=js"
export * from "./AllOrders.vue?vue&type=script&lang=js"

import "./AllOrders.vue?vue&type=style&index=0&id=b694620a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b694620a"]])

export default __exports__